import {Component, OnInit, input} from '@angular/core';
import * as ProfileActions from '../store/profile.actions';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import * as fromProfile from '../store/profile.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {ProfileService} from '../profile.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-profile-form',
    templateUrl: './profile-form.component.html',
    styleUrls: ['./profile-form.component.scss'],
    standalone: false
})
export class ProfileFormComponent implements OnInit {

  profileForm: UntypedFormGroup;
  hasLimit: boolean;
  profileState: Observable<fromProfile.State>;
  channelType: string;
  readonly size = input<'small' | 'large'>(undefined);
  readonly redirect = input<boolean>(undefined);

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService,
    private notifierService: ToastrService
  ) { }

  ngOnInit() {
    this.channelType = 'instagram';
    this.initForm();
    this.profileState = this.store.select('profile');
    this.profileService.hasActiveLimit().subscribe(
      (hasLimit: boolean) => {
        this.hasLimit = hasLimit;
      }
    );
  }

  setChannelType(type: string) {
    this.channelType = type;
  }

  onSubmit() {
    if (this.profileForm.valid) {
      const profile = this.profileForm.value.profile.trim().replace('@', '');
      this.store.dispatch(
        new ProfileActions.AddAuditCheck({profile: profile, channelType: this.channelType, redirect: this.redirect()})
      );
      if (!this.hasLimit) {
        this.notifierService.warning('You have no credits. The audit was added as a trial');
      }
    }

  }

  onPaste(event: ClipboardEvent) {
    const regexInstagram = /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/([A-Za-z0-9-_\.]+)/i;
    const regexTiktok = /(?:(?:http|https):\/\/)?(?:www.)?(?:tiktok.com|vm.tiktok.com)\/@([A-Za-z0-9-_\.]+)/i;
    this.profileForm.controls['profile'].reset();

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    const regInstagram = pastedText.match(regexInstagram);
    const regTiktok = pastedText.match(regexTiktok);
    let array = [];
    if (regInstagram !== null) {
      array = [...regInstagram];
      if (array.length === 2) {
        this.profileForm.controls['profile'].reset(array[1]);
        setTimeout(() => {
          this.channelType = 'instagram';
          console.log(this.profileForm.value.profile);
          const actualRegex = this.profileForm.value.profile.replace(pastedText, '');
          this.profileForm.controls['profile'].reset(actualRegex);
        }, 100);
      }
    }
    if (regTiktok !== null) {
      array = [...regTiktok];
      if (array.length === 2) {
        this.profileForm.controls['profile'].reset(array[1]);
        setTimeout(() => {
          this.channelType = 'tiktok';
          console.log(this.profileForm.value.profile);
          const actualRegex = this.profileForm.value.profile.replace(pastedText, '');
          this.profileForm.controls['profile'].reset(actualRegex);
        }, 100);
      }
    }
  }

  initForm() {
    this.profileForm = new UntypedFormGroup({
      'profile': new FormControl(null, Validators.required)
    });
  }
}
